import Fade from './Fade';
import ScaleFade from './ScaleFade';
import Transition from './Transition';
import SlideFade from './SlideFade';
import Stagger from './Stagger';
import Slide from './Slide';

export const Transitions = {
  Fade,
  ScaleFade,
  Transition,
  SlideFade,
  Stagger,
  Slide,
};

export default Transitions;
